import * as Immutable from 'immutable';
import * as React from 'react';

import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers';

import { FieldSetProps } from './types';
import { ErrorMsg } from './ErrorMsg';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

export const FieldSet = ({ label, id, modifiers = [], required = false, children, errors = Immutable.List() }: FieldSetProps) => (
  <div className={addModifiers('form__field-set', modifiers)}>
    {label && (
      <label htmlFor={id ? id : ''} className="form__label">
        <FormattedMessageHelper tagName="span" id={label} defaultMessage={localeData.en[label]} />
        {required && <sup>*</sup>}
      </label>
    )}
    {children}
    <div className="input__error">{errors.size !== 0 && <ErrorMsg errors={errors} />}</div>
  </div>
);
